var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoggedIn)?_c('div',{staticClass:"completed-checkbox"},[_c('TotemToggleButton',{attrs:{"label":_vm.buttonLabel,"editable":_vm.editable},model:{value:(_vm.showCompletedCheckbox),callback:function ($$v) {_vm.showCompletedCheckbox=$$v},expression:"showCompletedCheckbox"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }